import { HeaderTextProps } from "../components/organisms/Header/types";

const headerText: HeaderTextProps = {
  headerText: {
    greetings: "Hello",
    intro: "I'm",
    preTitle: "a",
  },
};

export default headerText;
